import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { AreaFilter } from '../filter';
import { AreaSearch, AreaSearchTotal } from '../area-search';

@Injectable({
    providedIn: 'root'
})
export class AreaSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/area`;
    }


    /** Realizada a pesquisa as áreas */
    search(filter: AreaFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<AreaSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<AreaSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa das áreas cadastradas */
    getTotais(filter: AreaFilter): Observable<AreaSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AreaSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
